import { useNavigate, useParams } from 'react-router-dom'

import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { ChevronLeft } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const ConsumerCompletedState = () => {
  const { trainingId } = useParams<{ trainingId: string }>()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const handleBack = () => {
    navigate(
      navigation.myTrainings.revamp.detailsRevamp.view.overview.fullPath({
        trainingId: trainingId ?? '',
      })
    )
  }
  return (
    <OneEmptyState
      actions={[
        {
          label: i18n.t('trainings.content.consumer.empty_state.back'),
          onClick: handleBack,
          variant: 'outline',
          icon: ChevronLeft,
        },
      ]}
      title={i18n.t('trainings.content.consumer.empty_state.title')}
      description={i18n.t('trainings.content.consumer.empty_state.description')}
      emoji="🎉"
    />
  )
}
